<template>
  <div class="count_box">
    <i class="iconfont icon-jinggao"></i>
    <span v-if="step === 1">验证通过后，请在5分钟内完成新手机绑定</span>
    <span v-else-if="step === 2">{{rs}}s 后验证失效，需重新验证</span>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'SmsCountDown',
  props: {
    step: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      inter: null,
      rs: 300 // 倒计时剩余秒数
    }
  },
  watch: {
    step (p) {
      const preT = Number(sessionStorage.getItem('$smsTime'))
      if (p === 2 && preT) {
        const cur = moment().valueOf()
        const pass = parseInt(moment.duration(cur - preT, 'ms').asSeconds())
        if (pass < 300) {
          this.rs = 300 - pass
          this.countSeconds()
        }
      }
      if (p === 3 && this.rs > 0) {
        clearInterval(this.inter)
        sessionStorage.removeItem('$smsTime')
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.inter)
  },
  methods: {
    countSeconds () {
      clearInterval(this.inter)
      this.inter = setInterval(() => {
        this.rs--
        if (this.rs === 0) {
          clearInterval(this.inter)
          sessionStorage.removeItem('$smsTime')
          this.$emit('update:step', 1)
        }
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
.count_box {
  border-radius: 4px;
  background-color: rgba(255, 57, 115, 0.05);
  color: #D50000;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  margin: 40px;
  text-align: center;
  .iconfont {
    margin-right: 6px;
  }
}
</style>
